module.exports = __webpack_public_path__ + "img/w23.3f4e2928.svg";